export default {
  'status': 'Translation validated by country',
  'meta': {
    'lang': 'Română'
  },
  'title': 'RECHEMARE PRODUS QUICKDRAWS SIMOND ALPINISM / VERTIKA',
  'homepage': {
    'notice': 'Rechemare de produs. Informații importante privind siguranța și echipamentul dumneavoastră.',
    'purchaseWindow': 'Ați achiziționat o buclă echipată de escaladă ALPINISM și/sau VERTIKA între 1 ianuarie 2022 și 23 iulie 2026.',
    'skus': 'Buclă echipată Alpinism 11 cm (4051175 / 8589547)\nBuclă echipată Alpinism 17 cm (4051176 / 8589548)\nSet 5 bucle echipate Alpinism (4171656 / 8608405)\nBuclă echipată Vertika 11 cm (5499689 / 8935765)\nBuclă echipată Vertika 17 cm (5500194 / 8935909)',
    'responsibility': 'Proiectarea echipamentelor individuale de protecție implică o responsabilitate absolută față de cei care le utilizează. Prin urmare, vă informăm cu privire la rechemarea buclei echipate dotate cu carabiniera Rocky Fil.',
    'defect': 'Am identificat un defect la nituirea clapetei din sârmă la anumite carabiniere. Acest defect de asamblare poate provoca ruperea clapetei și poate crea un risc de rupere a carabinierei în caz de cădere.',
    'stopUsing': 'Ca măsură de precauție, vă rugăm să opriți imediat utilizarea produsului dumneavoastră și să urmați procedura de mai jos.'
  },
  'procedure': {
    'stopUsing': 'Prin urmare, vă rugăm să încetați imediat utilizarea acestui echipament și să verificați dacă produsul dumneavoastră este afectat de acest defect, utilizând instrucțiunile de depanare de mai jos.',
    'title': 'Verificați produsele dumneavoastră:',
    'intro': 'Verificați dacă ambele părți ale încuietorii din sârmă rămân fixate în siguranță la carabină:',
    'step1': 'Luați carabina pe o parte, plasați degetul mare între cele două fire (degetul mare cel mai aproape de nit). Apăsați ferm în jos, pe carabină.',
    'step2': 'Întoarceți carabina și repetați aceeași acțiune pe cealaltă parte a încuietorii din sârmă.'
  },
  'outcome': {
    'nok': {
      'body': 'După inspecție, dacă firul s-a desprins: Vă rugăm să încetați imediat să utilizați produsul și să mergeți la cel mai apropiat magazin DECATHLON. Acolo, echipele noastre se vor ocupa de produsul defect și vor emite imediat o rambursare completă pentru aceste produse rechemate.',
      'support': 'Dacă întâmpinați dificultăți, echipa noastră de asistență clienți este disponibilă pentru a găsi o soluție personalizată și a vă ghida la fiecare pas: 0800 710 770, de luni până sâmbătă, între orele 9:00 și 19:00.'
    },
    'ok': {
      'body': 'În urma verificării, cablul nu iese din carcasa sa: Produsul dumneavoastră nu este afectat de acest defect și îl puteți utiliza în continuare în deplină siguranță.'
    }
  },
  'buttons': {
    'ok': 'Produsul meu este în regulă',
    'nok': 'Produsul meu este NOK'
  }
} as const
